import { render, staticRenderFns } from "./IconBulletList.vue?vue&type=template&id=2063b490"
import script from "./IconBulletList.vue?vue&type=script&lang=js"
export * from "./IconBulletList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports